import RouterApp from './routes';
import { QueryClientProvider, QueryClient } from 'react-query'
import 'moment/locale/id'
import toast, { useToasterStore } from 'react-hot-toast';
import { useEffect } from 'react';
import { initializeSignOzTracing, ErrorBoundary } from '@echoteam/signoz-react';
import ErrorPage from './components/ErrorPage';
import NetworkStatus from './components/atoms/NetworkStatus';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
})

// initializeSignOzTracing();

const APP_VERSION_KEY = 'app_version';

function App() {
  const { toasts } = useToasterStore()
  const TOAST_LIMIT = 3

  // Auto hard-reload saat versi app berubah setelah deploy baru.
  // config.js selalu fresh (nginx: no-store), sehingga window.REACT_APP_VERSION
  // selalu mencerminkan versi terbaru. Jika berbeda dengan yang tersimpan di
  // localStorage, reload halaman sekali — user tetap login, hanya bundle JS
  // yang diperbarui.
  useEffect(() => {
    const currentVersion = window.REACT_APP_VERSION;
    const storedVersion = localStorage.getItem(APP_VERSION_KEY);

    if (currentVersion && storedVersion !== currentVersion) {
      localStorage.setItem(APP_VERSION_KEY, currentVersion);
      window.location.reload();
    }
  }, [])

  // Enforce Limit
  useEffect(() => {
    toasts
      .filter(t => t.visible) // Only consider visible toasts
      .filter((item, i) => i >= TOAST_LIMIT) // Is toast index over limit
      .forEach(t => toast.dismiss(t.id)) // Dismiss – Use toast.remove(t.id) removal without animation
  }, [toasts])

  return (
    <QueryClientProvider client={queryClient}>
      <ErrorBoundary fallback={ErrorPage}>
        <NetworkStatus />
        <RouterApp />
      </ErrorBoundary>
    </QueryClientProvider>
  );
}

export default App;
